import React from "react"

import Caption from "../../../../design-system/caption"
import * as styles from "./index.module.scss"

interface Props {
  text: React.ReactNode
}

const CategoryHeader = ({ text }: Props) => {
  return <Caption className={styles.categoryHeader}>{text}</Caption>
}

export default CategoryHeader
